import { Component, Input, Output, EventEmitter } from '@angular/core';

export type LoadingStateType = 'fullscreen' | 'inline' | 'mini';

@Component({
  selector: 'tix-loading-state',
  templateUrl: './loading-state.component.html',
  styleUrls: ['./loading-state.component.scss']
})
export class LoadingStateComponent {
  @Input() isLoading = false;
  @Input() hasError = false;
  @Input() errorMessage = '';
  @Input() loadingText = 'Loading';
  @Input() loadingSubText = 'Setting up your workspace...';
  @Input() retryButtonText = 'Retry';
  @Input() type: LoadingStateType = 'fullscreen';
  @Input() showRetryButton = true;

  @Output() retryClicked = new EventEmitter<void>();

  onRetryClick(): void {
    this.retryClicked.emit();
  }
}
